import React from "react";
import { Grid,TextField } from "@material-ui/core";
import useStyles from "./Styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import userActions from "./actions";
import { useSelector } from "react-redux";
// import useIsDevUrl from "hooks/useIsDevUrl";

const FilterTogglebar = () => {
  const classes = useStyles();
  const { all_scenarios } = useSelector((state) => state.technical_view);
  const { setScenarioSelected } = userActions();
  const { scenario_selected } = useSelector(
    (state) => state.technical_view
  );

  // const scenario_options = [
  //   { label: "2022", value: "2022" },
  //   { label: "2023", value: "2023" },
  //   { label: "2024", value: "2024" },
  //   { label: "2025", value: "2025" },
  //   { label: "2026", value: "2026" },
  //   { label: "2027", value: "2027" },
  //   { label: "2028", value: "2028" },
  //   { label: "2029", value: "2029" },
  //   { label: "2030", value: "2030" },
  // ];



  const handleSelectedScenario = (e) => {
    setScenarioSelected(e);
  };

  const handleAutoCompleteScenario = (e, v) => {
    if (v !== null) handleSelectedScenario(v);
  };


  return (
    <Grid
      container
      spacing={2}
      classes={{ root: classes.filterContainer }}
      style={{ paddingTop: 20 }}
    >
      <Grid item>
        <Autocomplete
          id="location-select"
          value={all_scenarios.find((scenario_option) => scenario_option.value === scenario_selected.value) || {}}
          options={all_scenarios}
          renderOption={(option) =>  <div><b>{option.label}</b>: {option.description}</div>}
          getOptionLabel={(option) => option.label || ""}
          onChange={handleAutoCompleteScenario}
          disabled ={false}
          style={{ width:690 }}
          renderInput={(params) => (
            <TextField {...params} label={"Scenario"} variant="outlined" />
          )}
        />
        {/* <CustomizedSelect
          label="Scenario"
          // dropdownValue={scenario}
          dropdownValue={scenario}
          options={scenario_options}
          handleSelectedItem={handleSelectedScenario}
          // disabled={isDevUrl}
          disabled={false}
        /> */}
      </Grid>
      {/* <Grid item>
        <CustomizedSelect
          label="Big River Policy"
          dropdownValue={big_river_policy}
          options={big_river_options}
          handleSelectedItem={handleRiverPolicyChange}
        />
      </Grid> */}
    </Grid>
  );
};

export default FilterTogglebar;
